//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 05/08/2024
// Version : 1
// Description : Grafico de tanques por año
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import { PieChart } from "@mui/x-charts/PieChart";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useMediaQuery } from "@mui/material";

function Graf_motiv_inst(props) {
  const [cantidadTanques, setCantidadTanques] = useState([]);
  const { selectedDate } = props;
  const isMobile = useMediaQuery("(max-width:600px)"); // Detecta mobile

  const obtenerCantidadTanque = () => {
    const formattedDate = selectedDate.format("YYYY"); // Formatear la fecha seleccionada
    fetch(UrlApi + "/reclamos/cantidadTanquesPorcentaje/fecha/" + formattedDate)
      .then((response) => response.json())
      .then((data) => {
        setCantidadTanques(data);
      });
  };

  useEffect(() => {
    obtenerCantidadTanque();
  }, [selectedDate]);

  // Ordenar los datos de mayor a menor por cantidad de tanques
  const cantidadOrdenada = [...cantidadTanques].sort(
    (a, b) => b.cantidad - a.cantidad
  );

  // Calcular el total de tanques
  const totalTanques = cantidadOrdenada.reduce(
    (total, item) => total + item.cantidad,
    0
  );

  // Colores para cada segmento del gráfico
  const colors = [
    "#90B2EE",
    "#A8CEF2",
    "#F1D295",
    "#A8CEF2",
    "#F1A095",
    "#A5E59D",
  ];

  // Transformar los datos para el PieChart, incluyendo el porcentaje
  const data = (cantidadOrdenada || []).map((item, index) => ({
    label: `${item.tipo} (${((item.cantidad / totalTanques) * 100).toFixed(
      2
    )}%)`,
    value: item.cantidad,
    color: colors[index % colors.length], // Asignar color basado en el índice
  }));

  // Estilo para el contenedor del gráfico
  const paperStyle = {
    padding: "30px",
    width: "100%",
    margin: "auto",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  return (
    <div>
      <Paper elevation={3} style={paperStyle}>
        <Typography
          align="center"
          style={{
            fontWeight: "bold",
            fontSize: 20,
            color: "#333",
            marginBottom: "20px",
          }}
        >
          Porcentaje por tanque
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: isMobile ? "20px" : "60px",
            width: "100%",
          }}
        >
          {/* Gráfico */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: isMobile ? 85 : 0,
            }}
          >
            <PieChart
              width={isMobile ? 300 : 400}
              height={isMobile ? 300 : 400}
              series={[
                {
                  highlightScope: { faded: "global", highlighted: "item" },
                  faded: {
                    innerRadius: 30,
                    additionalRadius: -30,
                    color: "#ddd",
                  },
                  data,
                },
              ]}
              color={data.map((d) => d.color)}
              slotProps={{
                legend: {
                  hidden: true,
                },
              }}
            />
          </div>
          {/* leyenda  debajo del gráfico */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", // 1 columna en mobile, 2 en desktop
              gap: "8px 20px", // espacio entre filas y columnas
              justifyContent: "center",
              marginTop: isMobile ? "10px" : "0px",
            }}
          >
            {data.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "6px 0",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: item.color,
                    marginRight: "10px",
                    borderRadius: "10%",
                  }}
                ></div>
                <Typography
                  variant="body2"
                  align={isMobile ? "center" : "left"}
                >
                  {item.label}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </Paper>
    </div>
  );
}

export default Graf_motiv_inst;
